import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { List } from 'foundations-components/transitional/components/List';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { FREE, STARTER } from 'self-service-api/constants/ProductLevels';
import { ProductLevelAndProductLineToSuitePFTranslationKeyMap, ProductLevelToSuitePFHeaderTranslationKeyMap } from '../../../constants/PriorityFeaturesTranslationKeys';
import { useAppSelector } from '../../../reducers';
import { isUngatedForCommerceHubInbound25Selector } from '../../../selectors/GatingSelectors';
import ProductIcon from '../../common/ProductIcon';
import { Inbound25CopyChange } from '../../common/i18n/CopyChangeComponents';
import { FeaturesLayoutUI } from './FeaturesLayoutUI';
import { SuiteFeaturesSubtext } from './SuiteFeaturesSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SuiteFeatures = ({
  productLevel,
  loading,
  isCollapsible = false
}) => {
  const isUngatedForCommerceHubInbound25 = useAppSelector(isUngatedForCommerceHubInbound25Selector);
  const shouldHideCommerceHub = [FREE, STARTER].includes(productLevel) && isUngatedForCommerceHubInbound25;
  const DisplayedProductLines = shouldHideCommerceHub ? AllCombinedProductLines.filter(productLine => productLine !== 'COMMERCE') : AllCombinedProductLines;
  const HeaderSection = /*#__PURE__*/_jsx(Inbound25CopyChange, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ProductLevelToSuitePFHeaderTranslationKeyMap[productLevel]
    })
  });
  const FeaturesListSection = /*#__PURE__*/_jsx(List, {
    children: DisplayedProductLines.map((localProductLine, index) => {
      return /*#__PURE__*/_jsxs(Flex, {
        marginBlockStart: index > 0 ? '300' : undefined,
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(ProductIcon, {
          name: localProductLine,
          iconStyle: {
            blockSize: '32px',
            marginInlineEnd: '300'
          }
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Text, {
            typography: productLevel !== FREE ? 'body-125' : undefined,
            children: /*#__PURE__*/_jsx(Inbound25CopyChange, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: ProductLevelAndProductLineToSuitePFTranslationKeyMap[productLevel][localProductLine].title
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(SuiteFeaturesSubtext, {
              productLevel: productLevel,
              productLine: localProductLine
            })
          })]
        })]
      }, localProductLine);
    })
  });
  return /*#__PURE__*/_jsx(FeaturesLayoutUI, {
    loading: loading,
    HeaderSection: HeaderSection,
    FeaturesListSection: FeaturesListSection,
    isCollapsible: isCollapsible
  });
};